import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import Toggler from 'luminate/src/modules/toggler'
import Init from '../init'
import {redraw} from '../utilities'

const $body = $(document.body)

export default Toggler.extend({
	directive: 'lightbox',

	defaults: {
		event: 'click',
		content: ''
	},

	methods: {

		_setup()
		{
			$body.append(this.$lightbox)

			// Close the lightbox if clicked on the background
			this.$lightbox.on('click', e =>
			{
				if(e.target === this.$lightbox[0])
				{
					this.close()
				}
			})

			const that = this
			this.$lightbox.find('[lightbox-action]').on('click', function()
			{
				const $this = $(this)
				const action = $this.attr('lightbox-action')

				switch(action)
				{
					case 'close':
					{
						that.close()
						break;
					}
				}
			})

			Init(this.$lightbox[0])
		},

		open()
		{
			if(!this._hasSetup)
			{
				this._setup()
				this._hasSetup = true

				this.$lightbox.css('display', 'none')
				redraw(this.$lightbox[0])
			}

			this.$lightbox.fadeIn()
		},

		close()
		{
			this.$lightbox.fadeOut({
				complete: e =>
				{
					this.$lightbox.remove()
					this._hasSetup = false
				}
			})
		}
	},

	events: {

		init()
		{
			const $element = $(this.$element)
			this.$lightbox = $(this.$settings.content)

			$element.on(this.$settings.event, e =>
			{
				e.preventDefault()

				this.open()
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/legacy/modules/lightbox.js